// extracted by mini-css-extract-plugin
export default {"card":"u8M13aUO--styles_card__NubT7","cardWithPadding":"u8M13aUO--styles_cardWithPadding__6znod","shimmer":"u8M13aUO--styles_shimmer__gn7FI"};